import { ILivePreview } from "@/types";
import { apiRequest } from "./request";

interface GetLivePreviewsQuery {
    partnerId: string;
    startDate: string | null;
    endDate: string | null;
}

const getLivePreviews = (params: GetLivePreviewsQuery) => apiRequest<ILivePreview[]>(`/live-preview/`, "GET", params);

const trackLivePreview = (data: ILivePreview) =>
    apiRequest<ILivePreview>(
        "/live-preview/track",
        "POST",
        data,
    );


export default {
    trackLivePreview,
    getLivePreviews,
};
